import { Arrow } from './Arrow';

export default Arrow;
